import { Dialog } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledDialog = styled(Dialog) `
  width: 90vw;
  height: 90vh;
  margin: 5vh 5vw;
  max-width: unset;
  max-height: unset;
  border: unset;
`;
